import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import {
  Box,
  Grid,
  Hidden,
  Typography,
} from "@material-ui/core";

import { MUIBlock } from "../../MUI";
import * as styles from "./styles.scss";
import { SvgIcon } from "../../../../components";
import { tl } from "../../../../utils";
import { Head } from "../Course/Head";
import FSStore from "../store";
import { GroupsList } from "./list";
import FSCourseslistStore from "./store";



export const CoursesListContainer = observer(() => {
  const { fsStore, fsCourseslistStore } = React.useContext<{
    fsStore: FSStore
    fsCourseslistStore: FSCourseslistStore
  }>(MobXProviderContext);

  React.useEffect(() => {
    fsCourseslistStore.getGroupsList();
  }, [])

  React.useLayoutEffect(() => {
    if (!fsStore.isWidget) {
      document.querySelector("body").classList.add("no1200step");
    }
  }, [fsStore.isWidget])

  return fsStore.isWidget ? (
    <MUIBlock data={{ style: { minHeight: "100vh" } }} pInner={0}>
      <Head />
      <GroupsList />
    </MUIBlock>
  ) : (
    <>
      <MUIBlock mb={2}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <Box className={styles.titleIcon}>
              <SvgIcon type="fs-main" notimage />
            </Box>
          </Grid>
          <Grid item xs>
            <Box className={styles.title}>
              <Typography variant="subtitle1">
                <b>{tl("Файловое хранилище.")}</b>{" "}
                <Hidden only="xs">
                  {tl("Выберите курс, для просмотра файлов внутри него.")}
                </Hidden>
                <Hidden mdUp>{tl("Выберите курс.")}</Hidden>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </MUIBlock>
      <GroupsList />
    </>
  );
});
